var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-history-box"},[_c('NvHeader',{attrs:{"title":"Viewed"}}),_c('NvBookGrid',{attrs:{"books":_vm.books}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }